import { render, staticRenderFns } from "./FormPurchasePayment.vue?vue&type=template&id=f763c4a0"
import script from "./FormPurchasePayment.vue?vue&type=script&lang=js"
export * from "./FormPurchasePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports